
// import React, { useState } from "react";
// import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
// import { addDoc, collection, Timestamp } from "firebase/firestore";
// import { fireDB } from "../../firebase/FirebaseConfig";
// import { FaUser, FaMapMarkerAlt, FaPhone, FaUsers, FaCalendarAlt } from "react-icons/fa"; // icons
// import "./ClientForm.css";
// const ClientForm = () => {
//     const [formData, setFormData] = useState({
//         name: "",
//         destination: "",
//         tourists: "",
//         phone: "",
//         startDate: "",
//         endDate: "",
//         message: "",
//     });

//     const handleChange = (e) => {
//         setFormData((prev) => ({
//             ...prev,
//             [e.target.name]: e.target.value,
//         }));
//     };

//     const sendWhatsAppMessage = () => {
//         const { name, phone, destination, tourists, startDate, endDate, message } = formData;

//         const formattedStart = new Date(startDate).toLocaleDateString("en-IN");
//         const formattedEnd = new Date(endDate).toLocaleDateString("en-IN");

//         const text = `📝 *New Travel Enquiry*\n--------------------------\n📍 Name: ${name}\n📞 Phone: ${phone}\n✈️ Destination: ${destination}\n👥 Tourists: ${tourists}\n📅 Dates: ${formattedStart} to ${formattedEnd}\n📝 Message: ${message || "N/A"}`;

//         const phoneNumber = "917600668600";
//         const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
//         window.open(whatsappUrl, "_blank");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const { name, destination, tourists, phone, startDate, endDate } = formData;

//         if (!name || !destination || !tourists || !phone || !startDate || !endDate) {
//             alert("Please fill all required fields.");
//             return;
//         }

//         try {
//             await addDoc(collection(fireDB, "clientEnquiries"), {
//                 ...formData,
//                 createdAt: Timestamp.now(),
//             });

//             alert("✅ Thank you! We will contact you soon.");
//             sendWhatsAppMessage();

//             setFormData({
//                 name: "",
//                 destination: "",
//                 tourists: "",
//                 phone: "",
//                 startDate: "",
//                 endDate: "",
//                 message: "",
//             });
//         } catch (err) {
//             console.error("Error saving data", err);
//             alert("❌ Something went wrong.");
//         }
//     };

//     return (
//         <section className="py-5" style={{ background: "#f4f8fb" }}>
//             <Container>
//                 <Row className="justify-content-center">
//                     <Col xs={12} >
//                         <Card className=" shadow border-0 rounded-5 overflow-hidden w-100">
//                             <div className=" text-black text-center py-4">
//                                 <h3 className="fw-bold mb-0">Plan Your Travel</h3>
//                                 <p className="mb-0 small">We’ll help make your trip unforgettable!</p>
//                             </div>
//                             <Card.Body className="p-md-5 p-4 bg-light-gray bg-white">
//                                 <Form onSubmit={handleSubmit}>
//                                     <Row>
//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaUser className="me-2 text-primary" /> Your Name</Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     name="name"
//                                                     value={formData.name}
//                                                     onChange={handleChange}
//                                                     required
//                                                     className="rounded-pill shadow-sm"
//                                                     placeholder="Enter your name"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaMapMarkerAlt className="me-2 text-primary" /> Destination</Form.Label>
//                                                 <Form.Control
//                                                     type="text"
//                                                     name="destination"
//                                                     value={formData.destination}
//                                                     onChange={handleChange}
//                                                     required
//                                                     className="rounded-pill shadow-sm"
//                                                     placeholder="e.g. Goa, Manali"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaUsers className="me-2 text-primary" /> Number of Tourists</Form.Label>
//                                                 <Form.Control
//                                                     type="number"
//                                                     name="tourists"
//                                                     value={formData.tourists}
//                                                     onChange={handleChange}
//                                                     required
//                                                     min="1"
//                                                     className="rounded-pill shadow-sm"
//                                                     placeholder="e.g. 2, 4, 10"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaPhone className="me-2 text-primary" /> Phone Number</Form.Label>
//                                                 <Form.Control
//                                                     type="tel"
//                                                     name="phone"
//                                                     value={formData.phone}
//                                                     onChange={handleChange}
//                                                     required
//                                                     className="rounded-pill shadow-sm"
//                                                     placeholder="Enter your phone number"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaCalendarAlt className="me-2 text-primary" /> Start Date</Form.Label>
//                                                 <Form.Control
//                                                     type="date"
//                                                     name="startDate"
//                                                     value={formData.startDate}
//                                                     onChange={handleChange}
//                                                     required
//                                                     className="rounded-pill shadow-sm"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label><FaCalendarAlt className="me-2 text-primary" /> End Date</Form.Label>
//                                                 <Form.Control
//                                                     type="date"
//                                                     name="endDate"
//                                                     value={formData.endDate}
//                                                     onChange={handleChange}
//                                                     required
//                                                     className="rounded-pill shadow-sm"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={12}>
//                                             <Form.Group className="mb-4">
//                                                 <Form.Label>Message (optional)</Form.Label>
//                                                 <Form.Control
//                                                     as="textarea"
//                                                     rows={3}
//                                                     name="message"
//                                                     value={formData.message}
//                                                     onChange={handleChange}
//                                                     className="shadow-sm"
//                                                     placeholder="Write your message here"
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>

//                                     <div className="d-flex justify-content-center">
//                                         <Button
//                                             type="submit"
//                                             className="primaryBtn rounded-pill btn-lg px-5 shadow"
//                                             style={{ background: "#007bff", border: "none" }}
//                                         >
//                                             Submit Enquiry
//                                         </Button>
//                                     </div>
//                                 </Form>
//                             </Card.Body>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// };

// export default ClientForm;
import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import {
    FaUser,
    FaMapMarkerAlt,
    FaPhone,
    FaUsers,
    FaCalendarAlt,
} from "react-icons/fa";
import "./ClientForm.css";

const ClientForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        destination: "",
        tourists: "",
        phone: "",
        startDate: "",
        endDate: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const sendWhatsAppMessage = () => {
        const { name, phone, destination, tourists, startDate, endDate, message } =
            formData;

        const formattedStart = new Date(startDate).toLocaleDateString("en-IN");
        const formattedEnd = new Date(endDate).toLocaleDateString("en-IN");

        const text = `📝 *New Travel Enquiry*
--------------------------
📍 Name: ${name}
📞 Phone: ${phone}
✈️ Destination: ${destination}
👥 Tourists: ${tourists}
📅 Dates: ${formattedStart} to ${formattedEnd}
📝 Message: ${message || "N/A"}`;

        const phoneNumber = "917600668600";

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
            text
        )}`;

        window.location.href = whatsappUrl;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, destination, tourists, phone, startDate, endDate } = formData;

        if (!name || !destination || !tourists || !phone || !startDate || !endDate) {
            alert("⚠️ Please fill all required fields.");
            return;
        }

        try {
            await addDoc(collection(fireDB, "clientEnquiries"), {
                ...formData,
                createdAt: Timestamp.now(),
            });

            alert("✅ Thank you! We will contact you soon.");
            sendWhatsAppMessage();

            setFormData({
                name: "",
                destination: "",
                tourists: "",
                phone: "",
                startDate: "",
                endDate: "",
                message: "",
            });
        } catch (err) {
            console.error("Error saving data", err);
            alert("❌ Something went wrong.");
        }
    };

    return (
        <section className="py-5" style={{ background: "#f4f8fb" }}>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} >
                        <Card className="shadow border-0 rounded-5 overflow-hidden">
                            <div className="text-black text-center py-4 bg-light">
                                <h3 className="fw-bold mb-0">✈️ Plan Your Travel</h3>
                                <p className="mb-0 small text-muted">
                                    We’ll help make your trip unforgettable!
                                </p>
                            </div>
                            <Card.Body className="p-md-5 p-4 bg-white">
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaUser className="me-2 text-primary" /> Your Name
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    className="rounded-pill shadow-sm"
                                                    placeholder="Enter your name"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaMapMarkerAlt className="me-2 text-primary" />{" "}
                                                    Destination
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="destination"
                                                    value={formData.destination}
                                                    onChange={handleChange}
                                                    required
                                                    className="rounded-pill shadow-sm"
                                                    placeholder="e.g. Goa, Manali"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaUsers className="me-2 text-primary" /> Tourists
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="tourists"
                                                    value={formData.tourists}
                                                    onChange={handleChange}
                                                    required
                                                    min="1"
                                                    className="rounded-pill shadow-sm"
                                                    placeholder="e.g. 2, 4, 10"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaPhone className="me-2 text-primary" /> Phone Number
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                    className="rounded-pill shadow-sm"
                                                    placeholder="Enter your phone number"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaCalendarAlt className="me-2 text-primary" /> Start
                                                    Date
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="startDate"
                                                    value={formData.startDate}
                                                    onChange={handleChange}
                                                    required
                                                    className="rounded-pill shadow-sm"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    <FaCalendarAlt className="me-2 text-primary" /> End
                                                    Date
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="endDate"
                                                    value={formData.endDate}
                                                    onChange={handleChange}
                                                    required
                                                    className="rounded-pill shadow-sm"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group className="mb-4">
                                                <Form.Label>Message (optional)</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    className="shadow-sm"
                                                    placeholder="Write your message here"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="d-flex justify-content-center">
                                        <Button
                                            type="submit"
                                            className="rounded-pill btn-lg px-5 text-black shadow"
                                            style={{ background: "#f5bb2987", border: "none" }}
                                        >
                                            Submit Enquiry
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ClientForm;
